import React from 'react';
import styled from 'styled-components';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  height: 100%;
`;

const BoxIcon = styled.svg`
  width: 48px;
  height: 48px;
`;

const LogoText = styled.span`
  font-family: 'Arial', sans-serif;
  font-weight: bold;
  font-size: 28px;
  color: #000000;
  letter-spacing: 1px;
`;

const NordokLogo = ({ width = '100%', height = '100%' }) => {
  return (
    <LogoContainer style={{ width, height }}>
      <BoxIcon viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* 3D Box Icon */}
        <path d="M12 2L2 6.5V17.5L12 22L22 17.5V6.5L12 2Z" stroke="black" strokeWidth="2" />
        <path d="M2 6.5L12 11L22 6.5" stroke="black" strokeWidth="2" />
        <path d="M12 11V22" stroke="black" strokeWidth="2" />
      </BoxIcon>
      <LogoText>NORDOK</LogoText>
    </LogoContainer>
  );
};

export default NordokLogo; 